module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ch7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_vm._v("*")]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ROBERT SEYMOUR LOOKED TOWARDS THE ")]), _vm._v("empty pews with such intensity, and spoke with such conviction, that the church might have been filled with parishioners.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘Surely if anything can be certain knowledge to a man in this world,’ he said, ‘it must be whether he has a good conscience or no. If a man has the faculty of thought, then he must "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("know")]), _vm._v(" his own thoughts and desires, he must "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("know")]), _vm._v(" his past pursuits, he must "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("know")]), _vm._v(" the motives which have governed the actions of his life.’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘Robert, you must not move your head too much, so that it becomes the thing observed,’ said the vicar. ‘I would though raise your hand on each use of the word “know”, a little higher each time, so that it may be above your head on the third “know”. Continue.’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘The world, and other men, may deceive us with false appearances. How often do we guess correctly the true state of things on this earth? Only with great effort do we discover the truth of what lies before us. But the mind has all the facts and evidence it needs to know "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("itself")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘Head a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("little")]), _vm._v(" too close to the paper. Be mindful too of the passage in Milton about the preachers who throw their features into such distortions—’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘—as quite disfigure the human face divine.’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘Well remembered! Continue!’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("At the end of the sermon, the vicar approached the pulpit, looked up at the boy, and said: ‘Why did you come to me that evening, Robert?’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘I have told you already.’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘Please tell me again.’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘The Bible is my constant companion. It has inspired me to draw many pictures.’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘Your pictures, yes. Do you know, the first time you came to my study, I noticed how you looked at one of my prints on the wall, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("St Paul Preaching at Athens.")]), _vm._v(" I have seen you look at it every time we have been in the study since then. Does it inspire you?’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘My eyes move from one figure to another within the picture. The figures seem so varied in their appearances that I cannot possibly be wearied by it.’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘I meant did the portrayal of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("preaching")]), _vm._v(" inspire you.’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘It does.’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘And your mother – she wishes the church for you?’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("‘My mother has always striven to make me remember the words of the lesson on Sunday. She has always said that, one day, before the Lord, we will all be required to repeat them. I hope that, were I to give a sermon, it would help the congregation to remember the words.’")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The vicar moved contemplatively around the pulpit. ‘There are many things that remain to be worked upon – your tone of voice needs to convince the indifferent – many things – but the solemnity you have – your sense of solemnity, Robert, there is something there. Well – we will meet again next week, if you wish.’")]), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }, [_vm._v("‘I do.’")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22f2e68b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter7.vue
// module id = 93
// module chunks = 0